var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-tabs"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.id,staticClass:"history-tabs__tab",class:{ 'history-tabs__tab--active': _vm.value === tab.id },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('input', tab.id)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }